/**
 * React Compiler 互換のフル URL ナビゲーション（ハードナビゲーション）。
 * コンポーネントやフック内で `window.location.href` を直接書き換えると
 * 「Writing to a variable defined outside a component or hook」警告が発生するため、
 * 関数呼び出しでラップして回避する。
 *
 * OAuth リダイレクトなど、SPA のルーターではなくブラウザ全体の遷移が必要な場合に使う。
 * `replace: true` は履歴に残さない（OIDC で戻るボタンによる challenge URL ループを防ぐ）。
 */
export function navigateToUrl(url: string, options?: {
  replace?: boolean;
}) {
  if (options?.replace) {
    window.location.replace(url);
    return;
  }
  window.location.href = url;
}